function request(element = document.documentElement) {
  return new Promise((resolve, reject) => {
    if (element.requestFullscreen) {
      element.requestFullscreen().then(resolve).catch(reject)
    } else if (element.mozRequestFullScreen) {
      // Firefox
      element.mozRequestFullScreen().then(resolve).catch(reject)
    } else if (element.webkitRequestFullscreen) {
      // Chrome, Safari and Opera
      element.webkitRequestFullscreen().then(resolve).catch(reject)
    } else if (element.msRequestFullscreen) {
      // IE/Edge
      element.msRequestFullscreen().then(resolve).catch(reject)
    } else {
      reject(new Error('Fullscreen API is not supported'))
    }
  })
}

function exit() {
  return new Promise((resolve, reject) => {
    if (document.exitFullscreen) {
      document.exitFullscreen().then(resolve).catch(reject)
    } else if (document.mozCancelFullScreen) {
      // Firefox
      document.mozCancelFullScreen().then(resolve).catch(reject)
    } else if (document.webkitExitFullscreen) {
      // Chrome, Safari and Opera
      document.webkitExitFullscreen().then(resolve).catch(reject)
    } else if (document.msExitFullscreen) {
      // IE/Edge
      document.msExitFullscreen().then(resolve).catch(reject)
    } else {
      reject(new Error('Fullscreen API is not supported'))
    }
  })
}

function checkFullscreenStatus() {
  return !!(
    document.fullscreenElement ||
    document.mozFullScreenElement ||
    document.webkitFullscreenElement ||
    document.msFullscreenElement
  )
}

export default {
  request,
  exit,
  get isActive() {
    return checkFullscreenStatus()
  },
}
